// extracted by mini-css-extract-plugin
export default {"wrapper":"rBTbgU","sticky-editorx":"BG02Lg","stickyEditorx":"BG02Lg"};